import React from 'react';
import { Link } from 'react-router-dom';
import { footerData } from '../data/mockData';
import { Linkedin, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <a href="#" className="flex items-center gap-2 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_asisant-portal/artifacts/sagigh38_logo_w.png" 
                alt="Asisant" 
                className="h-12"
              />
            </a>
            <p className="text-[#c3c3c5] mb-6 leading-relaxed max-w-sm">
              {footerData.description}
            </p>
            
            {/* Social Links */}
            <div className="flex gap-4">
              <a href="https://www.linkedin.com/company/leire-io" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-xl flex items-center justify-center hover:bg-[#1297fd] transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Platform Links */}
          <div>
            <h4 className="font-bold text-white mb-6">Plataforma</h4>
            <ul className="space-y-4">
              <li>
                <Link to="/cloud-marketplace" className="text-[#c3c3c5] hover:text-[#40aaf8] transition-colors">
                  Cloud Marketplace
                </Link>
              </li>
              <li>
                <Link to="/automatizacion-contratos" className="text-[#c3c3c5] hover:text-[#40aaf8] transition-colors">
                  Automatización de Contratos
                </Link>
              </li>
              <li>
                <Link to="/soluciones-avanzadas" className="text-[#c3c3c5] hover:text-[#40aaf8] transition-colors">
                  Soluciones Avanzadas
                </Link>
              </li>
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-bold text-white mb-6">Empresa</h4>
            <ul className="space-y-4">
              <li>
                <Link to="/sobre-nosotros" className="text-[#c3c3c5] hover:text-[#40aaf8] transition-colors">
                  Sobre nosotros
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-[#c3c3c5] hover:text-[#40aaf8] transition-colors">
                  Contacto
                </Link>
              </li>
              <li>
                <Link to="/soporte" data-testid="footer-support-link" className="text-[#c3c3c5] hover:text-[#40aaf8] transition-colors">
                  Soporte
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-white mb-6">Contacto</h4>
            <ul className="space-y-4">
              <li>
                <a href="mailto:info@asisant.com" className="flex items-center gap-3 text-[#c3c3c5] hover:text-[#40aaf8] transition-colors">
                  <Mail className="w-5 h-5" />
                  info@asisant.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[#c3c3c5] text-sm">
              © 2025 Asisant. Todos los derechos reservados.
            </p>
            <div className="flex gap-6">
              <Link to="/privacidad" className="text-[#c3c3c5] text-sm hover:text-[#40aaf8] transition-colors">
                Privacidad
              </Link>
              <Link to="/terminos" className="text-[#c3c3c5] text-sm hover:text-[#40aaf8] transition-colors">
                Términos
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
